import * as action from '../constants/projectListing';
import cloneDeep from 'lodash/cloneDeep';

const initialState = {
  isLoading: true,
  projects: [],
  error: '',
  searchedText: '',
  projectId: '',
};

function projectListingReducer(state = initialState, actions) {
  const { type, payload } = actions;
  const oldState = cloneDeep(state);
  switch (type) {
    case action.HYP_UPDATE_LISTING_FETCH_STATUS:
      return {
        ...oldState,
        isLoading: payload,
      };
    case action.HYP_UPDATE_LISTING_PROJECTS:
      if (
        !payload ||
        payload?.error ||
        (payload?.response?.status !== 200 && payload?.status !== 'success')
      ) {
        return { ...oldState, error: payload };
      }
      return {
        ...oldState,
        projects: [...(payload?.data || [])],
      };
    case action.HYP_UPDATE_ADD_PROJECT_SUCCESS:
      if (
        !payload ||
        payload?.error ||
        (payload?.response?.status !== 200 && payload?.status !== 'success')
      ) {
        return { ...oldState, error: payload };
      }

      return {
        ...oldState,
        projectId: payload?.data?.id,
        projects: [{ ...payload.data }, ...oldState.projects],
      };
    case action.HYP_UPDATE_LISTING_ERROR:
      return {
        ...oldState,
        error: payload,
      };

    case action.HYP_UPDATE_LISTING_SEARCH_TEXT:
      return {
        ...oldState,
        searchedText: payload,
      };
    case action.HYP_RESET_PROJECT_LISTING:
      return {
        ...oldState,
        isLoading: true,
        projects: [],
        projectId: '',
      };
    default:
      return oldState;
  }
}

export default projectListingReducer;
